import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import {TranslateService} from '../../services/translate.service';
import {NgForOf} from '@angular/common';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [RouterModule, NgForOf],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent {
  plans = [
    { title: 'Trial', price: 'Free', desc: 'Try reconciliation with a small dataset' },
    { title: 'Standard', price: '€29/mo', desc: 'For small teams' },
    { title: 'Business', price: 'Contact us', desc: 'Custom limits & onboarding' }
  ];
  constructor(private tSvc: TranslateService) {}
  t(k:string){ return this.tSvc.translate(k); }
}
